import { createSelector } from '@ngrx/store';
import { IAppState } from '../app.state';
import { IUserState } from './user.state';

const selectUsers = (state: IAppState) => state.users;
export const selectUsersList = createSelector(
  selectUsers,
  (state: IUserState) => state?.users
);
export const getUserReqError = createSelector(
  selectUsers,
  (state: IUserState) => state.errors
);
export const selectImportErrors = createSelector(
  selectUsers,
  (state: IUserState) => state?.importErrors
);
export const selectImportSkipped = createSelector(
  selectUsers,
  (state: IUserState) => state.importSkipped
);
export const selectImportLoading = createSelector(
  selectUsers,
  (state: IUserState) => state?.loading?.importUsers
);
export const selectRegisterLoading = createSelector(
  selectUsers,
  (state: IUserState) => state.loading?.register
);
export const selectSelectedUser = createSelector(
  selectUsers,
  (state: IUserState) => state.selectedUser
);
export const selectUsersGroupsLoading = createSelector(
  selectUsers,
  (state: IUserState) => state.loading?.groups
);
export const selectUsersGroups = createSelector(
  selectUsers,
  (state: IUserState) => state?.groups
);
export const selectNewErrors = createSelector(
  selectUsers,
  (state: IUserState) => state.error
);
export const selectUsersLoading = createSelector(
  selectUsers,
  (state: IUserState) => state?.loading
);
export const selectUsersUnconfirmedCount = createSelector(
  selectUsers,
  (state: IUserState) => state.unconfirmedCount
);
export const selectUsersCount = createSelector(
  selectUsers,
  (state: IUserState) => state.count
);
export const selectProfileTabsLoading = createSelector(
  selectUsers,
  (state: IUserState) => state.profileTabsLoading
);
